export const SET_NEWSLETTER_FREQUENCY_MODAL_VIEWED = "SET_NEWSLETTER_FREQUENCY_MODAL_VIEWED";
